module.exports = __webpack_public_path__ + "static/restaurant-review-mobile-app-plp-fd7179c73816e471cc39bdff59dc063b.png";